/**
 * Header.js
 * Handles the sticky header styles when scrolled
 */

class Header {
  constructor() {
    const that = this;
    that.body = document.querySelector('body');
    that.header = document.querySelector(".site-header");

    if (that.header) {
      // Scroll
      window.addEventListener("scroll", function () {
        that.stickyHeader();
      });

      // Load
      window.addEventListener("load", function () {
        that.stickyHeader();
      });
    }
  }

  // Checks scrollbar position and makes the Header sticky
  stickyHeader() {
    const that = this;
    if (window.scrollY > 50 && that.header) {
      that.header.classList.add("site-header--sticky");
    } else {
      // if(burger menu is active)
      if (!this.body.classList.contains('js-menu-active')) {
        this.header.classList.remove('site-header--sticky');
      }
    }
  }
}

new Header();
